<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="门店名称" prop="shopName">
              <a-input v-model="formInline.shopName" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="负责人手机号码" prop="dutyPhone">
              <a-input v-model="formInline.dutyPhone" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="门店分类" prop="store">
              <a-select
                v-model="formInline.categoryId"
                placeholder="请选择"
                style="width: 150px"
                @change="storeType"
              >
                <a-select-option
                  v-for="(item, index) in xiala"
                  :key="index"
                  :value="item.objId"
                >
                  {{ item.categoryName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <storeManagementContent
          ref="iason"
          :formInline="formInline"
        ></storeManagementContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import storeManagementContent from "./storeManagementContent.vue";
import { storeListEditXiala } from "@/api/homeApi.js";
export default {
  components: {
    storeManagementContent,
  },
  created() {
    this.getStoreListEditXiala();
  },
  data() {
    return {
      // data: [],
      formInline: {
        categoryId: "",
        shopName: "",
        dutyPhone: "",
        merchantsId: "",
      },
      xiala: [],
    };
  },

  methods: {
    getStoreListEditXiala() {
      storeListEditXiala({ limit: 10, page: 1 }).then((res) => {
        this.xiala = res.data;
      });
    },
    storeType(e) {
      this.formInline.categoryId = e;
      console.log("oooooooooooooooooop", e);
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.iason.query();
    },
    handleChange() {},
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.$refs.iason.getData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/storeManagement/managementHom.vue